/**
 *  header-menu and sidebar menu data
 */

 export default [


   {  "menu_title": "Women",
      "type": "subMenu",
      "path": "/",
      "icon": "home",
      "child_routes": [            
   {  "path": "/women",
      "menu_title": "Women Latest Trend",
      "icon": "arrow_right_alt",
      "child_routes": null }]},

   {  "menu_title": "Men",
      "type": "subMenu",
      "path": "/men",
      "icon": "home",
      "child_routes": [            
   {  "path": "/men",
      "menu_title": "Men Latest Trend",
      "icon": "arrow_right_alt",
      "child_routes": null }]},

   {  "menu_title": "Modest",
      "type": "subMenu",
      "path": "/modest",
      "icon": "home",
      "child_routes": [            
   {  "path": "/modest",
      "menu_title": "Modest Latest Trend",
      "icon": "arrow_right_alt",
      "child_routes": null }]},

   {  "menu_title": "Plus Size",
      "type": "subMenu",
      "path": "/Plus_Size",
      "icon": "home",
      "child_routes": [            
   {  "path": "/Plus_Size",
      "menu_title": "Plus Size Latest Trend",
      "icon": "arrow_right_alt",
      "child_routes": null }]},

   {  "menu_title": "Blog",
      "path": "/Blog",
      "icon": "arrow_right_alt",
      "child_routes": null},

   {  "menu_title": "catalogue",
      "type": "subMenu",
      "path": "/product",
      "icon": "home",
      "child_routes":[    
         {  "path": "/product",
            "menu_title": "Cosmowolf",
            "icon": "arrow_right_alt",
            "child_routes": null },
         {  "path": "/product",
            "menu_title": "Fitmonkie",
            "icon": "arrow_right_alt",
            "child_routes": null },
         {  "path": "/product",
            "menu_title": "Jeramine",
            "icon": "arrow_right_alt",
            "child_routes": null },
         {  "path": "/product",
            "menu_title": "Moonwolfactive",
            "icon": "arrow_right_alt",
            "child_routes": null },
         {  "path": "/product",
            "menu_title": "Glowco",
            "icon": "arrow_right_alt",
            "child_routes": null },
         {  "path": "/product",
            "menu_title": "Kint.co",
            "icon": "arrow_right_alt",
            "child_routes": null },
         {  "path": "/product",
            "menu_title": "Konok",
            "icon": "arrow_right_alt",
            "child_routes": null },
         {  "path": "/product",
            "menu_title": "Wearconcrete",
            "icon": "arrow_right_alt",
            "child_routes": null },
         {  "path": "/product",
            "menu_title": "Wearpeachie",
            "icon": "arrow_right_alt",
            "child_routes": null }
         ]
                  
   },
   {
      "path": "/Aboutus",
      "menu_title": "About Us",
      "icon": "arrow_right_alt",
      "child_routes": null
   },
 ]

/*export default [
   {
      "menu_title": "Sales",
      "type": "subMenu",
      "path": "/",
      "icon": "home",
      "child_routes": [
         {
            "path": "/",
            "menu_title": "Home Default",
            "icon": "arrow_right_alt",
            "child_routes": null
         },
         {
            "path": "/index-new-fashion",
            "menu_title": "Home New Fashion",
            "icon": "arrow_right_alt",
            "child_routes": null
         },
         {
            "path": "/index-modern",
            "menu_title": "Home Modern",
            "icon": "arrow_right_alt",
            "child_routes": null
         },
         {
            "path": "/index-home-classic",
            "menu_title": "Home Classic",
            "icon": "arrow_right_alt",
            "child_routes": null
         },
      ]
   },
      {"menu_title": "Sales2",
      "type": "subMenu",
      "path": "/",
      "icon": "home",
      "child_routes": null},
      {"menu_title": "Sales2",
      "type": "subMenu",
      "path": "/",
      "icon": "home",
      "child_routes": null},
      {"menu_title": "Sales2",
      "type": "subMenu",
      "path": "/",
      "icon": "home",
      "child_routes": null},
   {
      "menu_title": "Women",
      "path": "/sidebar-with-load-more",
      "mega": true,
      "icon": "party_mode",
      "type": "subMenu",
      "child_routes": [
         {
            "path": "/sidebar-with-load-more",
            "menu_title": "Sidebar With Load More",
            "icon": "arrow_right_alt",
            "child_routes": null
         },
         {
            "path": "/topbar-with-load-more",
            "menu_title": "Topbar  With Load More",
            "icon": "arrow_right_alt",
            "child_routes": null
         },
         {
            "path": "/sidebar-without-lazyload",
            "menu_title": "Sidebar Without Lazyload",
            "icon": "arrow_right_alt",
            "child_routes": null
         },
         {
            "path": "/topbar-without-lazyload",
            "menu_title": "Topbar Without Lazyload",
            "icon": "arrow_right_alt",
            "child_routes": null
         },
         {
            "path": "/sidebar-with-lazyload",
            "menu_title": "Sidebar With Lazyload",
            "icon": "arrow_right_alt",
            "child_routes": null
         },
         {
            "path": "/shop/clothing/29",
            "menu_title": "Product Detail",
            "icon": "arrow_right_alt",
            "child_routes": null
         },
      ],
   },
   {
      "menu_title": "Men",
      "path": "/Blogfullwidth",
      "mega": true,
      "icon": "party_mode",
      "type": "subMenu",
      "child_routes": [
         {
            "path": "/Blogfullwidth",
            "menu_title": "Blog Full Width",
            "icon": "arrow_right_alt",
            "child_routes": null
         },
         {
            "path": "/Blogsinglepage",
            "menu_title": "Blog Post Single",
            "icon": "arrow_right_alt",
            "child_routes": null
         },
      ]
   },

   {
      "path": "/Aboutus",
      "menu_title": "About Us",
      "icon": "arrow_right_alt",
      "child_routes": null
   },

] */
